import { useCallback, useEffect, useState } from 'react';

const STORAGE_PREFIX = 'tizok-draft-';

function loadDraft(roomId: string): string {
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${roomId}`) ?? '';
  } catch {
    return '';
  }
}

function saveDraft(roomId: string, value: string) {
  if (value.length === 0) {
    localStorage.removeItem(`${STORAGE_PREFIX}${roomId}`);
  } else {
    localStorage.setItem(`${STORAGE_PREFIX}${roomId}`, value);
  }
}

export function useDraft(roomId: string) {
  const [draft, setDraftState] = useState<string>(() => loadDraft(roomId));

  // Re-sync when roomId changes — switching spaces loads that space's draft.
  useEffect(() => {
    setDraftState(loadDraft(roomId));
  }, [roomId]);

  const setDraft = useCallback(
    (value: string) => {
      setDraftState(value);
      saveDraft(roomId, value);
    },
    [roomId],
  );

  const clearDraft = useCallback(() => {
    setDraftState('');
    saveDraft(roomId, '');
  }, [roomId]);

  return { draft, setDraft, clearDraft };
}
